import React, {FunctionComponent} from 'react';

interface DescriptionProps {
  text?: string;
  children?: any;
}

const Description: FunctionComponent<DescriptionProps> = ({children, text}: DescriptionProps) => (
  <div className="trigger-dialog__description">
    {text}
    {children}
  </div>
);

export default Description;
